import { gql as e } from "@apollo/client";
const c = e`
  query GetTokenPriceToUSD($currencies: [CurrencyCode!]) {
    getTokenPriceToUSD(currencyCode: $currencies) {
      currencyCode
      price
    }
  }
`;
export {
  c as default
};
//# sourceMappingURL=getTokenPriceToUSD.js.map
